import React, {useEffect} from "react";
import {connect} from "react-redux";
import {RouterState, InjectedRouter} from "react-router/lib/Router";
import {getMostRecentDocument} from "routes/matter/utils/get_most_recent_document";
import {Matter} from "common/types/matter";
import {User} from "common/types/user";

type Props = {
  user: User;
  matter: Matter;
  router: RouterState & InjectedRouter;
  params: {
    organisationId: string;
    projectId: string;
    matterId?: string;
  };
};

const MatterDocumentContainer = (props: Props) => {
  useEffect(() => {
    if (props.matter?.documents) {
      const {organisationId, projectId, matterId} = props.params;
      const msaDocument = getMostRecentDocument(props.matter.documents, 1);

      if (msaDocument) {
        const redirectPath = `/organisation/${organisationId}/project/${projectId}/matter/${matterId}/document/${msaDocument.id}`;
        props.router.push(redirectPath);
      } else {
        const firstDocumentId = props.matter.documents[0].id;
        props.router.push(
          `/organisation/${organisationId}/project/${projectId}/matter/${matterId}/document/${firstDocumentId}`,
        );
      }
    }
  }, [props.matter, props.params]);

  return <div />;
};

function select(state) {
  return {
    matter: state.matter,
  };
}

export default connect(select)(MatterDocumentContainer);
